<template>
    <div id="subjectEdit">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary" @click="saveHandler" size="medium">保存</el-button>
        </div>
        <div class="form-container">
            <el-form
                :model="formData"
                label-width="150px"
                :rules="rules"
                ref="form"
            >
                <el-form-item label="课程名称" prop="courseName">
                    <div style="width: 500px;">
                        <el-input v-model="formData.courseName" placeholder="课程名称（1-40个字符）"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="课程学段" prop="learningTerm">
                    {{courseLevelValue}}
                </el-form-item>
                <el-form-item v-show="formData.courseLevelCode == 2" label="小学范围" prop="courseLevelCode">
                    <el-radio :label="0" v-model="formData.primaryType">
                        全部
                    </el-radio>
                    <el-radio :label="1" v-model="formData.primaryType">
                        小低
                    </el-radio>
                    <el-radio :label="2" v-model="formData.primaryType">
                        小高
                    </el-radio>
                </el-form-item>
                <el-form-item label="区域" prop="postCode">
                    {{areaName}}
                </el-form-item>
                <el-form-item label="课程封面" prop="imageJson">
                    <uploader pathPrefix="resourcePlatform"
                              :multiple="false" showResult="image" :showModeCover="true" showMode="cover" v-model="files" :extList="['jpeg', 'jpg', 'png', 'bmp', 'gif']">
                    </uploader>
                </el-form-item>
                <el-form-item label="课程介绍" prop="introdution">
                    <ueditor class="rich-editor" ref="ueditor" :defaultMes="formData.introdution"
                             @editModel="richTextEditHandler"></ueditor>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';

    import {updateMoralEduOLCourse, getMoralEduOLCourseInfo} from '@/api/resourceManagement/resourceManagement';
    import { findDicsByCode, getAreaByCode } from '@/api/common/common';
    import Ueditor from '@/components/Ueditor';
    import baseMixin from '@/mixins/baseMixin.js'

    export default {
        name: "subjectAdd",
        mixins: [baseMixin],
        data() {
            return {
                schoolPeriodList: [],
                id: this.$route.query.id,
                courseLevelValue: '',
                formData: {
                    courseName: '',
                    courseLevelCode: null,
                    imageJson: '',
                    introdution: '',
                    primaryType: 0,
                },
                customCoverUrl: '',
                areaName: '',
                rules: {
                    courseName: [{
                        required: true, message: '课程名称不能为空', trigger: 'blur'
                    }, {
                        min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur'
                    }],
                    imageJson: [{
                        required: true, message: '课程封面不能为空', trigger: 'blur'
                    }],
                    introdution: [{
                        required: true,
                        message: '课程介绍不能为空'
                    }]
                },
                files: [{
                    fileUrl: 'https://cdnfile-10043692.file.myqcloud.com/admin/images/subject-default-cover.jpg',
                    fileName: 'subject-default-cover.jpg'
                }],
            }
        },
        mounted() {
            findDicsByCode({
                dicCode: 'schoolPeriodType'
            })
                .then(res => res.data)
                .then(data => {
                    if(data.data.length > 0) {
                        this.schoolPeriodList = data.data;
                        getMoralEduOLCourseInfo({
                            id: this.id
                        })
                            .then(res => res.data)
                            .then(data => {
                                // data.data.imageJson = JSON.parse(data.data.imageJson);
                                const areaCode = data.data.areaCode;
                                getAreaByCode({
                                    areaCode
                                })
                                    .then(data => {
                                        this.areaName = data.name;
                                    });
                                data.data.primaryType = data.data.primaryType || 0;
                                this.formData = Object.assign({}, this.formData, data.data);
                                this.files = [{
                                    fileUrl: data.data.imageJson,
                                    fileName: ''
                                }];
                                this.courseLevelValue = this.schoolPeriodList.find(item => item.code === data.data.courseLevelCode).value;
                                this.$refs.ueditor.setContent(this.formData.introdution);
                                setTimeout(() => {
                                    this.$refs.form.validateField('introdution');
                                }, 100)
                            })
                    }
                })
        },
        components: {
            Ueditor,
            Uploader
        },
        methods: {
            richTextEditHandler(introdution) {
                this.formData.introdution = introdution;
                this.$refs.form.validateField('introdution');
            },
            saveHandler() {
                this.formData.imageJson = this.files[0].fileUrl;
                const args = this.formData;
                this.$refs.form.validate((valid) => {
                    if(valid) {
                        args.introdution = this.$refs.ueditor.getContent();
                        updateMoralEduOLCourse({
                            courseName: this.formData.courseName,
                            imageJson: this.formData.imageJson,
                            introdution: this.formData.introdution,
                            courseLevelCode: this.formData.courseLevelCode,
                            id: this.id,
                            primaryType: this.formData.courseLevelCode == 2 ? this.formData.primaryType : 0,
                            moralType: 1001
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message({
                                        message: '编辑课程成功',
                                        type: 'success'
                                    });
                                    this.$router.back();
                                }
                            });
                    }

                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    @include reset-global;

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }
    .form-container {
        margin-top: 162px;
        width: 65%;
        padding-top: 20px;
    }
    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 146px;
        vertical-align: top;
        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }
        font-size: 28px;
        color: #8c939d;
    }
    .logo-image {
        display: inline-block;
        width: 315px;
        height: 175px;
        @include cover-bg;
    }
</style>
<style lang="scss">
    #subjectEdit {
        .upload-file-item {
            width: 315px;
            height: 175px;
            img {
                display: inline-block;
                width: 315px;
                height: 175px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceManagement/subjectEdit.vue